export const insert = <T>(content: T[], widget: T, destination: number): T[] => [
  ...content.slice(0, destination),
  widget,
  ...content.slice(destination),
];
